import React from "react";
import { Link } from "react-router-dom";
import { Heart, ShoppingBag, X } from "lucide-react";
import { useApp } from "../context/AppContext";
import { formatPrice } from "../i18n/translations";

const WishlistPage = () => {
  const { t, wishlist, products, currency, toggleWishlist, addToCart } = useApp();
  const items = products.filter((p) => wishlist.includes(p.id));

  return (
    <main className="py-20 min-h-[60vh]" data-testid="wishlist-page">
      <div className="max-w-[1300px] mx-auto px-6 lg:px-10">
        <h1 className="font-display text-4xl lg:text-5xl mb-10 text-center">{t.wishlist.title}</h1>
        {items.length === 0 ? (
          <div className="text-center py-20">
            <Heart className="w-12 h-12 mx-auto text-[var(--grey)] mb-4" strokeWidth={1} />
            <p className="text-[var(--grey)] mb-6">{t.wishlist.empty}</p>
            <Link to="/shop" className="link-lux text-xs tracking-[0.25em] uppercase">{t.cart.continueShopping}</Link>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {items.map((p) => (
              <div key={p.id} className="bg-white relative group">
                <button onClick={() => toggleWishlist(p.id)} className="absolute top-3 right-3 w-9 h-9 bg-white/90 z-10 flex items-center justify-center">
                  <X className="w-4 h-4" />
                </button>
                <Link to={`/product/${p.slug}`}>
                  <img src={p.images[0]} alt={p.name} className="w-full aspect-[4/5] object-cover" />
                </Link>
                <div className="p-5">
                  <h3 className="font-serif text-lg">{p.name}</h3>
                  <div className="text-sm mt-1 mb-4">{formatPrice(p.price, currency)}</div>
                  <button onClick={() => p.in_stock && addToCart(p.id)} disabled={!p.in_stock} className="btn-lux w-full bg-[var(--noir)] text-[var(--ivory)] py-3 text-[11px] tracking-[0.25em] uppercase hover:text-[var(--gold)] disabled:bg-[var(--grey-soft)] disabled:cursor-not-allowed">
                    <ShoppingBag className="w-4 h-4 inline mr-2" /> {p.in_stock ? t.product.addToCart : t.product.soldOut}
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </main>
  );
};

export default WishlistPage;
